import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { services } from './ServicesDataPrivateCloud';
import { Timeline } from '../../ui/timeline';
import ExpertiseSection from '../../HomePage/ExpertiseSectionHome/ExpertiseSectionHome';

const TimelinePrivateCloud: React.FC = () => {
  const { t } = useTranslation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const translatedServices = useMemo(() => {
    return services.map((service, index) => ({
      ...service,
      title: service.titleKey ? t(service.titleKey, service.title) : t(`incidentCyber.timeline.services.${index + 1}.title`, service.title),
      description: service.descriptionKey ? t(service.descriptionKey, service.description) : t(`incidentCyber.timeline.services.${index + 1}.description`, service.description),
      features: service.features.map((feature, featureIndex) => ({
        text: t(`incidentCyber.timeline.services.${index + 1}.features.${featureIndex + 1}`, feature.text)
      }))
    }));
  }, [t]);

  const timelineItems = translatedServices.map(service => ({
    date: "",
    title: service.title,
    description: service.description,
    icon: service.icon,
    features: service.features.filter(f => f.text !== '')
  }));

  return (
    <div 
      className="tw-container tw-mx-auto pb-16 bg-transparent tw-px-4 sm:px-4 md:px-4 lg:px-0 xl:px-0 2xl:px-0"
      style={{ 
        paddingLeft: windowWidth < 1279 ? '0' : '',
        paddingRight: windowWidth < 1279 ? '0' : ''
      }}
    >
      <div className="centered-title-dark-bg-approche">
        <h2>{t('incidentCyber.timeline.title', 'Notre approche')}</h2>
        <ExpertiseSection 
          translationKey="expertiseSection.timelineText"
          translationNamespace="incidentCyber"
          defaultText="Face au chaos généré par une attaque, nous appliquons une méthodologie rigoureuse et éprouvée, inspirée des meilleurs standards de l'industrie (NIST, SANS). Chaque étape est conçue pour restaurer l'ordre, minimiser l'impact et transformer la crise en une opportunité de renforcement."
        />
      </div>
      <Timeline items={timelineItems} />
    </div>
  );
};

export default TimelinePrivateCloud;